import Grid from "components/Grid";
import Text from "components/Text";
import { FC } from "react";
import { RiUserLine } from "react-icons/ri";
import CardTitle from "../CardTitle";
import {
    Bullet,
    BulletColumn,
    CardWrapper,
    Label,
} from "./PersonalInfo.styled";
import { usePersonalInfo } from "./usePersonalInfo";

export const PersonalInfo: FC = () => {
    const { gender, nationality, dob, qualification } = usePersonalInfo();

    return (
        <CardWrapper>
            <CardTitle icon={<RiUserLine />} title="Personal Info" />
            {gender || nationality || dob || qualification ? (
                <Grid
                    row={true}
                    expanded
                    justify="flex-start"
                    columnGap={1}
                    rowGap={1}
                    marginTop={1}
                >
                    {gender && (
                        <BulletColumn>
                            <Label variant="body2">Gender</Label>
                            <Bullet>
                                <Text variant="body2">{gender}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                    {nationality && (
                        <BulletColumn>
                            <Label variant="body2">Nationality</Label>
                            <Bullet>
                                <Text variant="body2">{nationality}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                    {dob && (
                        <BulletColumn>
                            <Label variant="body2">Date of Birth</Label>
                            <Bullet>
                                <Text variant="body2">{dob}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                    {qualification && (
                        <BulletColumn>
                            <Label variant="body2">Qualification</Label>
                            <Bullet>
                                <Text variant="body2">{qualification}</Text>
                            </Bullet>
                        </BulletColumn>
                    )}
                </Grid>
            ) : (
                <Grid
                    row={true}
                    expanded
                    justify="flex-start"
                    columnGap={1}
                    marginTop={1}
                >
                    <Text variant="body1">No data found.</Text>
                </Grid>
            )}
        </CardWrapper>
    );
};
